export default __webpack_public_path__ + "static/media/curved-slope.c84f368c.svg";